import { Application } from '../app/models/application';
import { ApplicationInterface } from '../app/interface/application';
import { ApplicantBasic } from '../app/models/applicantbasic';
import { ApplicantBasicInterface } from '../app/interface/applicantBasic';
import { ApplicantPersonal } from '../app/models/applicantpersonal';
import { ApplicantPersonalInterface } from '../app/interface/applicantpersonal';
import { MoveInReason } from '../app/models/moveinreason';
import { MoveInReasonInterface } from '../app/interface/moveinreason';
import { LeasingAgent } from '../app/models/leasingagent';
import { LeasingAgentInterface } from '../app/interface/leasingagent';
import { MaritalStatus } from '../app/models/maritalstatus';
import { MaritalStatusInterface } from '../app/interface/maritalstatus';
import { PetType } from '../app/models/pettype';
import { PetTypeInterface } from '../app/interface/pettype';
import { Industry } from '../app/models/industry';
import { IndustryInterface } from '../app/interface/industry';
import { Property } from '../app/models/property';
import { PropertyInterface } from '../app/interface/property';
import { PropertiesInterface } from '../app/interface/properties';
import { OtherOccupant } from '../app/models/otheroccupant';
import { Pet } from '../app/models/pet';
import { AddApplicant } from '../app/models/addapplicant';
import { AddApplicantInterface } from '../app/interface/addapplicant';
import { BackgroundCheck } from '../app/models/BackgroundCheck';
import { BackgroundCheckInterface } from '../app/interface/backgroundcheck';
import { Document } from '../app/models/document';
import { DocumentInterface } from '../app/interface/document';
import { CognitoUtil } from './cognito.service';
import { environment } from '../environments/environment';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';

import { VisitedHome } from 'app/models/visited-home';
import { VisitedHomeInterface } from 'app/interface/visited-home';
import { EmploymentStatus } from 'app/models/employmentstatus';
import { EmploymentStatusInterface } from 'app/interface/employmentstatus';
import { RentalRates } from 'app/models/rental-rates';
import { RentalRatesTerm } from 'app/models/rental-rates-term';
import { RentalRatesDay } from 'app/models/rental-rates-day';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LabelValue } from 'app/models/labelvalue';
import { UploadDocumentTracking } from 'app/models/upload-document-tracking';

@Injectable()
export class ApplicationDataService {
    public static _API_ENDPOINT = environment.apiEndPoint;

    constructor(private http: HttpClient, private cognitoUtil: CognitoUtil, private router: Router, private errorService: ErrorService) { }

    createOptions() {
        this.cognitoUtil.refresh();
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('AWSCreds'),
                'Identity': localStorage.getItem('CognitoId'),
                'Sub': localStorage.getItem('CognitoSub')
            })
        };
    }

    createOptionsWithoutContentType() {
        this.cognitoUtil.refresh();
        return {
            headers: new HttpHeaders({
                'Authorization': localStorage.getItem('AWSCreds'),
                'Identity': localStorage.getItem('CognitoId'),
                'Sub': localStorage.getItem('CognitoSub')
            })
        };
    }

    acceptInvitation(invitationID: string) {
        return this.http.get<number>(ApplicationDataService._API_ENDPOINT + 'Application/AcceptInvitation/' + invitationID, this.createOptions());
    }

    getInvitationApplication(invitationID: string) {
        return this.http.get<ApplicationInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetInvitationApplication/' + invitationID, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface>(response))
            );
    }

    getLandingPaymentOptions() {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/LandingPaymentOptions')
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );
    }

    getAppFeeByProperty(yardiKey: string) {
        return this.http.get<number>(ApplicationDataService._API_ENDPOINT + `Application/GetApplicationFeeByProperty?yardiKey=${yardiKey}`)
            .pipe(
                catchError(this.processError),
                map((response) => <number>(response))
            );
    }

    getApplications() {
        return this.http.get<ApplicationInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplications', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface[]>(response))
            );
    }

    getApplicationPrimaryApplicantName(ApplicationKey: string) {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicationPrimaryApplicantName/' +
            ApplicationKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );

    }

    createApplication(application: Application) {

        application.UnitCode = localStorage.getItem('mfunitcode');
        if (application.UnitCode != null) {
            application.YardiKey = localStorage.getItem('YardiKey');
        } else {
            application.YardiKey = localStorage.getItem('YardiKey');
        }
        return this.http.post<ApplicationInterface>(ApplicationDataService._API_ENDPOINT + 'Application/CreateApplication', application, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface>(response))
            );
    }

    continueApplication(RentalApplicationKey: number) {
        return this.http.get<ApplicationInterface>(ApplicationDataService._API_ENDPOINT + 'Application/ContinueApplication/' + RentalApplicationKey.toString(),
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface>(response))
            );
    }

    updateApplicantID(emailAddress: string) {
        return this.http.post(ApplicationDataService._API_ENDPOINT + 'Application/UpdateApplicantID', { Email: emailAddress },
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => (response))
            );
    }

    getBasicInformation(RentalApplicationKey: string, RentalApplicantKey: string, AddAdditionalApplicantKey: string) {
        return this.http.get<ApplicantBasicInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicantBasicInfo?RentalApplicantKey=' +
            RentalApplicantKey + '&RentalApplicationKey=' + RentalApplicationKey + '&AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicantBasicInterface>(response))
            );
    }

    updateBasicInformation(basicInfo: ApplicantBasic) {
        return this.http.post<ApplicantBasicInterface>(ApplicationDataService._API_ENDPOINT + 'Application/UpdateApplicantBasicInfo', basicInfo,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicantBasicInterface>(response))
            );
    }

    getPersonalInformation(RetnalApplicationKey: string, RentalApplicantKey: string, AddAdditionalApplicantKey: string) {
        return this.http.get<ApplicantPersonalInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicantPersonalInfo?RentalApplicantKey=' +
            RentalApplicantKey + '&RentalApplicationKey=' + RetnalApplicationKey + '&AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicantPersonalInterface>(response))
            );
    }

    updatePersonalInformation(personalInfo: ApplicantPersonal, occupants: OtherOccupant[], pets: Pet[]) {
        personalInfo.Pets = pets;
        personalInfo.Occupants = occupants;

        return this.http.post<ApplicantPersonalInterface>(ApplicationDataService._API_ENDPOINT + 'Application/UpdateApplicantPersonalInfo',
            personalInfo, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicantPersonalInterface>(response))
            );
    }

    getRentalMaritalStatuses() {
        return this.http.get<MaritalStatusInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetMaritalStatuses', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <MaritalStatusInterface[]>(response))
            );
    }

    getEmploymentStatuses() {
        return this.http.get<EmploymentStatusInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetEmploymentStatuses', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <EmploymentStatusInterface[]>(response))
            );
    }

    getRentalMoveInReasons() {
        return this.http.get<MoveInReasonInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetMoveInReasons', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <MoveInReasonInterface[]>(response))
            );
    }

    getLeasingAgentOptions(applicationKey: number) {
        return this.http.get<LeasingAgentInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetLeasingAgentOptions?rentalApplicationKey=' +
            applicationKey.toString(), this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <LeasingAgentInterface[]>(response))
            );
    }

    getLeaseTermOptions(applicationKey: number, DMID: Date) {
        let dmidDate = new Date(DMID);
        return this.http.get<number[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetLeaseTermOptions?rentalApplicationKey=' +
            applicationKey.toString() + '&modelDMID=' + dmidDate.toDateString(), this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <number[]>(response))
            );
    }

    getLeaseTermOptionsOnChange(applicationKey: number, DMID: Date) {
        let dmidDate = new Date(DMID);
        return this.http.get<number[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetLeaseTermOptions?rentalApplicationKey=' +
            applicationKey.toString() + '&modelDMID=' + dmidDate.toDateString(), this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <number[]>(response))
            );
    }

    getRentalPetTypes() {
        return this.http.get<PetTypeInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetPetTypes', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <PetTypeInterface[]>(response))
            );
    }

    InviteApplicant(Invitation: AddApplicant) {
        return this.http.post<AddApplicantInterface>(ApplicationDataService._API_ENDPOINT + 'Application/InviteRentalApplicant', Invitation, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <AddApplicantInterface>(response))
            );
    }

    reinviteApplicant(Invitation: AddApplicant) {
        return this.http.post<AddApplicantInterface>(ApplicationDataService._API_ENDPOINT + 'Application/ReinviteRentalApplicant', Invitation, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <AddApplicantInterface>(response))
            );
    }

    checkInviteRecord(Invitation: AddApplicant) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/CheckInviteRecord', Invitation, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    checkAdditionalApplicantRecord(AddedApplicant: ApplicantBasic) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/CheckAdditionalApplicantRecord', AddedApplicant, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    assignOrCreateAdditionalApplicant(AddedApplicant: ApplicantBasic) {
        return this.http.post<number>(ApplicationDataService._API_ENDPOINT + 'Application/AssignOrCreateAdditionalApplicant', AddedApplicant, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <number>(response))
            );
    }

    getBackgroundCheck(RentalApplicationKey: string, RentalApplicantKey: string, AddAdditionalApplicantKey: string) {
        return this.http.get<BackgroundCheckInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetBackgroundCheck?RentalApplicationKey=' +
            RentalApplicationKey + '&RentalApplicantKey=' + RentalApplicantKey + '&AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, this.createOptions())
            .pipe(
                catchError(this.processError),
                map((response) => <BackgroundCheckInterface>(response))
            );
    }

    updateBackgroundCheck(BackgroundCheck: BackgroundCheck, CompletedByOther: boolean) {
        return this.http.post<BackgroundCheckInterface>(ApplicationDataService._API_ENDPOINT + 'Application/UpdateBackgroundCheck?CompletedByOther=' + CompletedByOther, BackgroundCheck,
            this.createOptions())
            .pipe(
                catchError(this.processError),
                map((response) => <BackgroundCheckInterface>(response))
            );
    }

    verifyBackgroundCheck(RentalApplicationKey: string, RentalApplicantKey: string) {
        return this.http.get<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/VerifyBackgroundCheck?RentalApplicationKey=' +
            RentalApplicationKey + '&RentalApplicantKey=' + RentalApplicantKey, this.createOptions())
            .pipe(
                catchError(this.processError),
                map((response) => <boolean>(response))
            );
    }

    getProperties() {
        return this.http.get<PropertiesInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetWaitlist', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <PropertiesInterface>(response))
            );
    }

    checkPropertyWaitList(RentalApplicationKey: number, UpdateApplicationStatus: boolean) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/CheckForWaitList?RentalApplicationKey=' + RentalApplicationKey + '&UpdateApplicationStatus=' + UpdateApplicationStatus,
            RentalApplicationKey,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    getReferralProperties() {
        return this.http.get<string[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetReferralProperties', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <string[]>(response))
            );

    }

    getProperty(YardiKey: string) {
        return this.http.get<PropertyInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetPropertyFromWaitlist/' + YardiKey.trim())
            .pipe(
                catchError(this.handleError),
                map((response) => <PropertyInterface>(response))
            );
    }

    checkPropertyForSFRC(YardiKey: string) {
        return this.http.get<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/CheckPropertyForSFRC?YardiKey=' + YardiKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    getPropertyForShowing(YardiKey: string) {
        return this.http.get<PropertyInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetPropertyForShowing/' + YardiKey)
            .pipe(
                catchError(this.handleError),
                map((response) => <PropertyInterface>(response))
            );
    }

    getMFProperty(YardiKey: string, mfUnitCode: string) {
        return this.http.get<PropertyInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetMFProperty?yardiKey=' + YardiKey + "&mfUnitCode=" + mfUnitCode)
            .pipe(
                catchError(this.handleError),
                map((response) => <PropertyInterface>(response))
            );
    }

    getPublishedMFPropertyList() {
        return this.http.get<PropertiesInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetWaitlistMF', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <PropertiesInterface>(response))
            );
    }

    getRentalRates(YardiKey: string, mfUnitCode: string) {
        return this.http.get<RentalRates>(ApplicationDataService._API_ENDPOINT + 'Application/GetRentalRatesForUnit?yardiKey=' + YardiKey + "&unitKey=" + mfUnitCode, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => {
                    if (response !== null) {
                        return this.processRentalRateResponse(response);

                    } else {
                        return null;
                    }
                })
            );
    }

    getRentalRatesSF(YardiKey: string) {
        return this.http.get<RentalRates>(ApplicationDataService._API_ENDPOINT + 'Application/GetRentalRatesSF?yardiKey=' + YardiKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => {
                    if (response !== null) {
                        return this.processRentalRateResponse(response);
                    } else {
                        return null;
                    }
                })
            );
    }

    getRentalRatesSFRC(yardiKey: string, rentalApplicationKey: number, desiredMoveInDate: Date, daysToGetPricingFor: number) {

        let queryString = `yardiKey=${yardiKey}&rentalApplicationKey=${rentalApplicationKey}&desiredMoveInDate=${desiredMoveInDate.toDateString()}&daysToGetPricingFor=${daysToGetPricingFor}`;

        return this.http.get<RentalRates>(ApplicationDataService._API_ENDPOINT + `Application/GetRentalRatesSFRC?${queryString}`,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => {
                    if (response !== null) {
                        return this.processRentalRateResponse(response);
                    } else {
                        return null;
                    }
                })
            );
    }

    processRentalRateResponse(response) {
        let result = <RentalRates>response;
        result.LeaseTermsMap = new Map<number, RentalRatesTerm>();
        result.DayTermOptionsMap = new Map<string, RentalRatesDay>();
        result.DayTermRentMap = new Map<string, number>();
        result.LeaseTermOptions = [];

        result.BestLeaseTermDate = new Date(result.BestLeaseTermDate);
        result.BestLeaseTermDateShort = result.BestLeaseTermDate.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
        result.LeaseTerms.forEach(function (part, index) {
            part.Dates.forEach(function (rent, index2, array) {
                let date = new Date(rent.Date);
                array[index2].Date = date;
                result.DayTermRentMap.set(`${date.getUTCFullYear()}-${date.getUTCMonth()}-${date.getUTCDate()}-${part.LeaseTerm}`, rent.Rent)
            });
            result.LeaseTermsMap.set(part.LeaseTerm, part);
            result.LeaseTermOptions.unshift({ label: part.LeaseTerm + " Months", value: part.LeaseTerm });
        }, result.LeaseTerms);
        result.DayTermOptions.forEach(function (part, index, array) {
            array[index].Date = new Date(part.Date);
            result.DayTermOptionsMap.set(`${array[index].Date.getUTCFullYear()}-${array[index].Date.getUTCMonth()}-${array[index].Date.getUTCDate()}`, part);
        });
        return result;
    }

    getApplicantApplicationForProperty(YardiKey: string) {
        return this.http.get<ApplicationInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicantApplicationForProperty/' + YardiKey,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface>(response))
            );
    }

    getPreviousAdditionalRentalApplicants() {
        return this.http.get<AddApplicantInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetPreviousOtherRentalApplicants', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <AddApplicantInterface[]>(response))
            );
    }

    addAdditionalProperty(property: Property, additionalApplicants: AddApplicant[], source: String, campaign: String, adgroup: String, keyword: String, adcopy: String, device: String, duplicate: boolean, medium: String) {
        let trackingString = "";

        trackingString += '&source=';
        if (source) {
            trackingString += source;
        }
        trackingString += '&campaign=';
        if (campaign) {
            trackingString += campaign;
        }
        trackingString += '&adgroup=';
        if (adgroup) {
            trackingString += adgroup;
        }
        trackingString += '&keyword=';
        if (keyword) {
            trackingString += keyword;
        }
        trackingString += '&adcopy=';
        if (adcopy) {
            trackingString += adcopy;
        }
        trackingString += '&device=';
        if (device) {
            trackingString += device;
        }
        trackingString += `&medium=`;
        if (medium) {
            trackingString += medium;
        }

        return this.http.post<ApplicationInterface>(ApplicationDataService._API_ENDPOINT + 'Application/AddAdditionalProperty?id=' + property.unit_code + '&duplicate=' + duplicate + trackingString,
            additionalApplicants, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface>(response))
            );
    }

    cancelExistingApplication(yardiKey: string){
        return this.http.post(ApplicationDataService._API_ENDPOINT + 'Application/CancelApplicantApplicationsByProperty', yardiKey, this.createOptions())
        .pipe(
            catchError(this.processError),
            map((response) => response)
        );
    }

    getRentalIndustries() {
        return this.http.get<IndustryInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetRentalIndustries', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <IndustryInterface[]>(response))
            );
    }

    getApplicantsForApplication(applicationKey: number) {
        return this.http.get<ApplicantBasicInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicantsForApplication/' +
            applicationKey.toString(), this.createOptions())
            .pipe(
                catchError(this.processError),
                map((response) => <ApplicantBasicInterface[]>(response))
            );
    }

    getCurrentApplication(applicationKey: number) {
        return this.http.get<ApplicationInterface>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplication/' +
            applicationKey.toString(), this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <ApplicationInterface>(response))
            );
    }

    uploadApplicantDocument(formData: FormData, AddAdditionalApplicantKey: number) {
        const requestOptions = this.createOptionsWithoutContentType();
        requestOptions.headers.append('Accept', 'multipart/json');

        return this.http.post(ApplicationDataService._API_ENDPOINT + 'Application/UploadFiles?AddAdditionalApplicantKey=' + AddAdditionalApplicantKey + '&fromEmploymentStep=null', formData, requestOptions)
            .pipe(
                catchError(this.handleError),
                map((response) => (response))
            );
    }

    uploadApplicantProofOfIncome(formData: FormData, AddAdditionalApplicantKey: number) {
        const requestOptions = this.createOptionsWithoutContentType();
        requestOptions.headers.append('Accept', 'multipart/json');

        return this.http.post(ApplicationDataService._API_ENDPOINT + 'Application/UploadFiles?AddAdditionalApplicantKey=' + AddAdditionalApplicantKey + '&fromEmploymentStep=true', formData, requestOptions)
            .pipe(
                catchError(this.handleError),
                map((response) => (response))
            );
    }

    getApplicantDocuments(AddAdditionalApplicantKey: number) {
        return this.http.get<DocumentInterface[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicantDocuments?AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <DocumentInterface[]>(response))
            );
    }

    getDocumentTypes() {
        return this.http.get<LabelValue[]>(ApplicationDataService._API_ENDPOINT + 'Application/GetApplicantDocumentTypes', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <LabelValue[]>(response))
            );
    }

    updateApplicantDocument(document: Document, AddAdditionalApplicantKey: number) {
        return this.http.post<DocumentInterface>(ApplicationDataService._API_ENDPOINT + 'Application/UpdateApplicantDocument?AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, document, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <DocumentInterface>(response))
            );
    }

    deleteApplicantDocument(AddAdditionalApplicantKey: number, document: Document) {
        return this.http.post<DocumentInterface>(ApplicationDataService._API_ENDPOINT + 'Application/DeleteApplicantDocument?AddAdditionalApplicantKey=' + AddAdditionalApplicantKey, document, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <DocumentInterface>(response))
            );
    }

    getCaseCorrectEmail(email: string) {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/GetCaseCorrectUsername?email=' + email)
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );
    }

    getCaseCorrectEmailForPasswordReset(email: string) {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/GetCaseCorrectUsernameForPasswordReset?email=' + email)
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );
    }

    removeApplicantFromApplication(rentalApplicationKey: number, rentalApplicantKey: number) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/RemoveApplicantFromApplication?rentalApplicationKey=' + rentalApplicationKey + "&rentalApplicantKey=" + rentalApplicantKey, null,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    removeApplicantInvitationFromApplication(rentalApplicationKey: number, rentalApplicationInvitationKey: number) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/RemoveApplicantInvitationFromApplication?rentalApplicationKey=' + rentalApplicationKey + "&rentalApplicationInvitationKey=" + rentalApplicationInvitationKey, null,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    getActiveApplicationConfirmation(RentalApplicationKey: string) {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/GetActiveApplicationConfirmation?RentalApplicationKey=' + RentalApplicationKey,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );

    }

    getHomesVisited() {
        return this.http.get<VisitedHomeInterface[]>(ApplicationDataService._API_ENDPOINT + 'DoorCode/GetHomesVisited', this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <VisitedHomeInterface[]>(response))
            );
    }

    GetIncomeVerificationMessageForApplication(RentalApplicationKey: string) {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/GetIncomeVerificationMessageForApplication?rentalApplicationKey=' + RentalApplicationKey, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );
    }

    checkIfSmartHomeMarket(RentalApplicationKey: string) {
        return this.http.get<string>(ApplicationDataService._API_ENDPOINT + 'Application/CheckIfSmartHomeMarket?rentalApplicationKey=' + RentalApplicationKey,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <string>(response))
            );
    }

    markSmartHomeTokenAsUsed(token: string) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/MarkSmartHomeTokenAsViewed?token=' + token, null)
            .pipe(
                catchError(this.handleError)
            );
    }

    markAnyoneHomeTokenAsUsed(token: string) {
        return this.http.post<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/MarkAnyoneHomeTokenAsViewed?token=' + token, null)
            .pipe(
                catchError(this.handleError)
            );
    }

    checkIsPrimary(RentalApplicationKey: number) {
        return this.http.get<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/CheckIsPrimary?rentalApplicationKey=' + RentalApplicationKey,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    checkIsCorrectStatus(RentalApplicationKey: number) {
        return this.http.get<boolean>(ApplicationDataService._API_ENDPOINT + 'Application/CheckIsCorrectStatus?rentalApplicationKey=' + RentalApplicationKey,
            this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    uploadDocumentTracking(trackingInfo: UploadDocumentTracking) {
        return this.http.post(ApplicationDataService._API_ENDPOINT + 'Application/UploadDocumentTracking', trackingInfo, this.createOptions())
            .pipe(
                catchError(this.handleError)
            );
    }

    renderDocumentTracking(yardiKey: string, rentalApplicationKey: number) {
        return this.http.get<boolean>(ApplicationDataService._API_ENDPOINT + `Application/RenderDocumentTracking?yardiKey=${yardiKey}&rentalApplicationKey=${rentalApplicationKey}`, this.createOptions())
            .pipe(
                catchError(this.handleError),
                map((response) => <boolean>(response))
            );
    }

    publishRentalApplicationCompletedEvent(rentalApplicationKey: number) {
        return this.http.post(ApplicationDataService._API_ENDPOINT + 'Application/PublishRentalApplicationCompletedEvent?rentalApplicationKey=' + rentalApplicationKey, null, this.createOptions())
            .pipe(
                catchError(this.handleError)
            );
    }
    
    handleError = (response: HttpErrorResponse) => {
        let errMsg: string;
        if (response.status === 403) {
            this.router.navigate(['/logout']);
        }
        if (response.error instanceof ErrorEvent) {
            const body = response.error;
            if (body.message) {
                errMsg = response.error.message;
            } else {
                const err = body;
                errMsg = `${response.statusText || ''} ${err}`;
            }
        } else {
            errMsg = response.message ? response.message : response.toString();
            if (errMsg.length === 0) {
                errMsg = 'There was an unknown error.  Please try again later';
            }
        }
        return errMsg;
    }

    processError = (error: HttpErrorResponse | any) => {
        let errMsg: string;
        if (error.status === 403) {
            this.router.navigate(['/logout']);
        }

        if (error.status > 499) {
          return throwError("An unknown error has occurred.\nIf the problem persists, please contact Tricon support.");
        }

        if (error.error) {
            const body = error.error;
            if (body.message) {
                errMsg = body.message;
            }
            else if (body.Message) {
                errMsg = body.Message;
            }
            else {
                const err = body;
                errMsg = `${error.statusText || ''} ${err}`;
            }
        } else {
            errMsg = error.message ? error.message : error.toString();
            if (errMsg.length === 0) {
                errMsg = 'There was an unknown error.  Please try again later';
            }
        }
        return throwError(errMsg);
    }
}
